import { compareByAlphabet } from 'src/helpers/sorting';
import type {
  BrandsOverviewsTransformed,
  GetBrandsOverviewsResponseSchema,
  GetPlatformIntegrationStatusesResponse,
  GetPlatformsResponse,
  GetPlatformTrackingEventsResponse,
  PlatformIntegrationStatusesTransformed,
  PlatformsTransformed,
  PlatformTrackingEventsTransformed,
} from 'src/types/platforms';

export const transformGetPlatformsResponse: (res: GetPlatformsResponse) => PlatformsTransformed = (res) =>
  res.values
    .map((platform) => ({
      ...platform,
      brands: platform.brands.sort((a, b) => compareByAlphabet(a.brandName, b.brandName)),
    }))
    .sort((a, b) => compareByAlphabet(a.platformName, b.platformName));

export const transformGetPlatformIntegrationStatusesResponse: (
  res: GetPlatformIntegrationStatusesResponse,
) => PlatformIntegrationStatusesTransformed = (res) => res.values;

export const transformGetPlatformTrackingEventsResponse: (
  res: GetPlatformTrackingEventsResponse,
) => PlatformTrackingEventsTransformed = (res) => res.values;

export const transformGetBrandsOverviewsResponse: (
  res: GetBrandsOverviewsResponseSchema,
) => BrandsOverviewsTransformed = (res) => res.values;
